import { render } from "./type-chart.vue?vue&type=template&id=3b3f56f2"
import script from "./type-chart.vue?vue&type=script&lang=ts"
export * from "./type-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script